import { render } from "./TopBar.vue?vue&type=template&id=5225fa97"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"

import "./TopBar.vue?vue&type=style&index=0&id=5225fa97&lang=scss"

import exportComponent from "/Users/billyhan/Sites/sol-v3/web/wp-content/themes/swinburne/assets/Eligibility/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__